import type { JSX } from 'react';
import { Vervolgstap } from '@common/customControls/bariatrics';
import { BariPostCaroInactivityFormEdit } from '../BariPostCaroInactivityFormEdit';

export function BariPostCaroInactivitySecretarialAssistantReportEdit(): JSX.Element {
    const vervolgStappen: Vervolgstap[] = [
        Vervolgstap.vragenlijsten_opnieuw_beschikbaar_maken,
        Vervolgstap.geen_actie_nodig,
    ];

    return <BariPostCaroInactivityFormEdit vervolgStappen={vervolgStappen} />;
}
